import { useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';
import type {
// WSCashOutData,
WSCouponDataSB
// WSInsuranceData
} from '@mwl/core-lib';
import { removeCouponCreateV2ById, resetCouponCreateV2, resetCouponSelectedV2, selectCreatedCouponsV2, selectUserIsAuthenticated,
// updateCouponHistoryCashOut,
// updateCouponHistoryInsurance,
updateCouponHistoryV2, useCouponInitialBetAmount, usePrevious,
// useWebsocketCashOut,
useWebsocketCoupon
// useWebsocketInsurance,
} from '@mwl/core-lib';
import { CouponErrorMessage } from '@/components/CouponErrorMessage/CouponErrorMessage';
import { base } from '@/constants';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
export const useCouponData = () => {
  const dispatch = useTypedDispatch();
  const isAuth = useTypedSelector(selectUserIsAuthenticated);
  const prevAuth = usePrevious(isAuth);
  const onUpdateCoupon = useCallback((data: WSCouponDataSB) => {
    dispatch(updateCouponHistoryV2(data));
  }, [dispatch]);

  // NOTE: пока нет функционала страховки и выкупа - подписки не нужны

  // const onUpdateCashOut = useCallback(
  //   (data: WSCashOutData) => {
  //     dispatch(updateCouponHistoryCashOut(data));
  //   },
  //   [dispatch],
  // );

  // const onUpdateInsurance = useCallback(
  //   (data: WSInsuranceData) => {
  //     dispatch(updateCouponHistoryInsurance(data));
  //   },
  //   [dispatch],
  // );

  useCouponInitialBetAmount();
  useWebsocketCoupon({
    projectName: base.NAME_PROJECT,
    onUpdate: onUpdateCoupon
  });
  // useWebsocketInsurance({ projectName: base.NAME_PROJECT, onUpdate: onUpdateInsurance });
  // useWebsocketCashOut({ projectName: base.NAME_PROJECT, onUpdate: onUpdateCashOut });

  useEffect(() => {
    if (prevAuth && !isAuth) {
      dispatch(resetCouponSelectedV2());
    }
  }, [isAuth, dispatch, prevAuth]);
  useEffect(() => {
    return () => {
      dispatch(resetCouponCreateV2());
    };
  }, [dispatch]);
};
export const useCouponNotifications = (containerId: string) => {
  const dispatch = useTypedDispatch();
  const createdCoupons = useTypedSelector(selectCreatedCouponsV2);
  const handleCloseError = useCallback((couponId: string) => {
    dispatch(removeCouponCreateV2ById(couponId));
  }, [dispatch]);
  useEffect(() => {
    createdCoupons.forEach(coupon => {
      if (coupon.status === 'REJECTED') {
        toast.error(props => <CouponErrorMessage {...props} coupon={coupon} />, {
          containerId,
          onClose: () => handleCloseError(coupon.id)
        });
      }
    });
  }, [createdCoupons, containerId, handleCloseError]);
};